import React from 'react';
import ButtonPrimary from '../Form/ButtonPrimary';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import ButtonOpenStoreCounter from './ButtonOpenStoreCounter';
import StepsStoreCounter from './StepsStoreCounter';
import { useStoreContext } from '../../Contexts/StoreContext';
import Img from './Img';
import { useTranslation } from 'react-i18next';

const WelcomeStoreCounter = () => {

    const { t } = useTranslation();
    const { company, setWelcomeScreenRead } = useLayoutContext();
    const { cashier } = useStoreContext();

    return (
        <div className="flex flex-col items-center gap-3 md:gap-6 w-full h-full p-6 md:w-8/12">
            <img src={company.square_image} alt="" className="w-36 sm:w-40 md:44 transition-width ease-in-out duration-200" />
            <div className="grid gap-2">
                <h2 className="font-extrabold text-xl text-shopfood-title">{t('store_counter.welcome.title')} {company.name}</h2>
                <div className="flex flex-col gap-0.5 text-gray-500">
                    <span className='text-lg font-bold text-custom-primary'>{t('store_counter.welcome.subtitle')}</span>
                    <span className='leading-none'>{t('store_counter.welcome.text_1')}</span>
                    <span className='leading-none'>{t('store_counter.welcome.text_2')}</span>
                    <span className='leading-none'>{t('store_counter.welcome.text_3')}</span>
                </div>
            </div>
            <div>
                <StepsStoreCounter />
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 w-full text-lg">
                {cashier && <ButtonOpenStoreCounter forceLabel label={t('store_counter.button_open_label')} />}
                <ButtonPrimary outline onClick={() => setWelcomeScreenRead(true)} className='items-center justify-center w-full text-nowrap sm:max-w-64'>{t('store_counter.button_view_menu_label')}</ButtonPrimary>
            </div>
            <div className='text-center mt-1'>
                <Img src='/logo-ditti-color.png' alt="Ditti" className='max-h-6 inline' />
            </div>
        </div>
    );
};

export default WelcomeStoreCounter;
